import { useState } from "react";
import CarInfoAddEdit from "./CarInfoAddEdit";
import Button from "../../ui/Button";
import { AddIcon, DeleteIcon, EditIcon } from "../../utils/icon.utils";
import Table from "../../ui/Table/Table";
import { GroupBtn } from "../../ui/GroupBtn";
import { useDeleteCarInfoMutation, useGetAllCarInfoQuery } from "../../utils/carInfo.utils";
import { tableIndex } from "../../utils/table.utils";
import { onConfirm } from "../../utils/sweetAlert.utils";
import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import CarInfoFilter from "./CarInfoFilter";
import { arrayMap } from "../../utils/array.utils";

export default function CarInfoPage() {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState(null);
  const [activeFilterId, setActiveFilterId] = useState("");

  const [modal, setModal] = useState(false);

  const toggle = () => {
    if (modal) {
      setEditItem(null);
    }
    setModal((prev) => !prev);
  };

  const { loading, data } = useGetAllCarInfoQuery({
    query: `?page=${currentPage}&size=${pageSize}&type=${activeFilterId}`
  });

  const { loading: deleting, deleteCarInfo } = useDeleteCarInfoMutation(["deleteCarInfo"]);

  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  const breadCrumbs = [
    {
      name: "Car",
      link: "/car"
    },
    {
      name: "Car Info"
    }
  ];

  const thead = ["#", "Type", "Parent", "Name", "Action"];

  const tbody =
    arrayMap(data?.data, (item, index) => ({
      "#": tableIndex(index, currentPage, pageSize),
      Name: item?.name ?? "-",
      Parent: item?.parent?.name ?? "-",
      Type: item?.car_info_type?.name ?? "-",
      ...item
    })) || [];

  const ActionComponent = ({ data }) => {
    const handleEdit = (item) => {
      setEditItem(item);
      toggle();
    };

    const handleDelete = async (item) => {
      const { isConfirmed } = await onConfirm();
      if (isConfirmed) {
        await deleteCarInfo(item?.id);
      }
    };

    const btns = [
      {
        icon: DeleteIcon,
        onClick: () => handleDelete(data),
        color: "danger"
      },
      {
        icon: EditIcon,
        onClick: () => handleEdit(data),
        color: "primary"
      }
    ];
    return <GroupBtn btns={btns} justify="start" />;
  };

  const isLoading = loading || deleting;

  const handleFilter = (filterId) => {
    setActiveFilterId(filterId);
  };

  return (
    <PageLayout title="Car Info" subTitle={`Total: ${data?.total ?? 0}`} breadCrumbs={breadCrumbs}>
      <div className="d-flex align-items-center justify-content-end gap-1">
        <Button color="primary" icon={AddIcon} name="Create Car Info" onClick={toggle} />
        <CarInfoFilter activeId={activeFilterId} handleClick={handleFilter} />
      </div>

      {loading ? "Loading..." : ""}

      <Table
        thead={thead}
        tbody={tbody}
        action={ActionComponent}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
      />

      {modal && <CarInfoAddEdit modal={modal} toggle={toggle} editItem={editItem} />}
      {<Loading loading={isLoading} />}
    </PageLayout>
  );
}
